import { render, staticRenderFns } from "./tipusMPList.vue?vue&type=template&id=45901680&scoped=true"
import script from "./tipusMPList.vue?vue&type=script&lang=js"
export * from "./tipusMPList.vue?vue&type=script&lang=js"
import style0 from "./tipusMPList.vue?vue&type=style&index=0&id=45901680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45901680",
  null
  
)

export default component.exports